var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProffesion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34356 15.3719C0.987913 15.3719 0.675074 15.2369 0.405044 14.9669C0.135015 14.6968 0 14.3774 0 14.0086V4.62343C0 4.25461 0.135015 3.93519 0.405044 3.66516C0.675074 3.39513 0.987913 3.26011 1.34356 3.26011H4.74198V1.34356C4.74198 0.987913 4.877 0.675074 5.14703 0.405044C5.41705 0.135015 5.73648 0 6.1053 0H9.9384C10.3072 0 10.6266 0.135015 10.8967 0.405044C11.1667 0.675074 11.3017 0.987913 11.3017 1.34356V3.26011H14.7001C15.069 3.26011 15.3851 3.39513 15.6485 3.66516C15.912 3.93519 16.0437 4.25461 16.0437 4.62343V14.0086C16.0437 14.3774 15.912 14.6968 15.6485 14.9669C15.3851 15.2369 15.069 15.3719 14.7001 15.3719H1.34356ZM6.1053 3.26011H9.9384V1.34356H6.1053V3.26011Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProffesion);
export default __webpack_public_path__ + "static/media/proffesion.578f9a567175015a6a7bdf753fd6c769.svg";
export { ForwardRef as ReactComponent };